"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
var ServerStore = (_class = /*#__PURE__*/function () {
  function ServerStore() {
    (0, _classCallCheck2["default"])(this, ServerStore);
    (0, _initializerDefineProperty2["default"])(this, "errorMessage", _descriptor, this);
    (0, _initializerDefineProperty2["default"])(this, "successMessage", _descriptor2, this);
    (0, _initializerDefineProperty2["default"])(this, "loading", _descriptor3, this);
    (0, _initializerDefineProperty2["default"])(this, "connectionProblem", _descriptor4, this);
    (0, _initializerDefineProperty2["default"])(this, "userFriendlyErrorMessage", _descriptor5, this);
  }
  return (0, _createClass2["default"])(ServerStore, [{
    key: "setConnectionProblem",
    value: function setConnectionProblem(connectionProblem) {
      this.connectionProblem = connectionProblem;
    }
  }, {
    key: "setErrorMessage",
    value: function setErrorMessage(message) {
      this.errorMessage = message;
    }
  }, {
    key: "setSuccessMessage",
    value: function setSuccessMessage(message) {
      this.successMessage = message;
    }
  }, {
    key: "clearMessages",
    value: function clearMessages() {
      this.errorMessage = null;
      this.successMessage = null;
    }
  }, {
    key: "setLoading",
    value: function setLoading(loading) {
      this.loading = loading;
    }
  }, {
    key: "setUserFriendlyErrorMessage",
    value: function setUserFriendlyErrorMessage(message) {
      this.userFriendlyErrorMessage = message;
    }
  }, {
    key: "clearUserFriendlyErrorMessage",
    value: function clearUserFriendlyErrorMessage() {
      this.userFriendlyErrorMessage = null;
    }
  }]);
}(), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "errorMessage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "successMessage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "loading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "connectionProblem", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "userFriendlyErrorMessage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _class);
var _default = exports["default"] = new ServerStore();